import "../../assets/css/sms-legal-links.css";
import { PRIVACY_NOTICE_URL, SMS_TERMS_URL } from "./smsConsentCopy";

/**
 * The SMS Terms and Privacy Notice links, rendered on their own line.
 *
 * The links live in code rather than in the configurable copy so every event
 * carries them regardless of what a page has saved for its SMS opt-in message.
 */
export function SmsLegalLinks() {
  return (
    // Legal-approved copy (Twilio SC 56170 compliance) - render exactly as written, not translated.
    <p className="sms-legal-links">
      View our{" "}
      <a href={SMS_TERMS_URL} target="_blank" rel="noopener noreferrer">
        SMS Terms
      </a>{" "}
      and{" "}
      <a href={PRIVACY_NOTICE_URL} target="_blank" rel="noopener noreferrer">
        Privacy Notice
      </a>
      .
    </p>
  );
}

export default SmsLegalLinks;
